import { cloneDeep } from './object';

export function addNewCell(table, row, column, CELL) {
  table.push({
    ...cloneDeep(CELL),
    positionx: row.toString(),
    positiony: column.toString(),
    text: '',
  });
}

export function isCellCompatible(index, letter, table) {
  const currentChar = table[index].text;
  return currentChar === '' || currentChar === letter;
}

export function fillRandomLetters(table) {
  const simpleLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const accented = 'ÁÉÍÓÚÂÊÔÃÕÇ';
  const accentChance = 0.1; // 10%

  return table.map(cell => {
    if (cell.text !== '') return cell;

    const useAccent = Math.random() < accentChance;
    const letters = useAccent ? accented : simpleLetters;

    const randomIndex = Math.floor(Math.random() * letters.length);
    return { ...cell, text: letters[randomIndex] };
  });
}
